function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTileRainFuture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "100.703 75.557 128.69 128.69",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 128.69,
    height: 128.69,
    rx: 17.64,
    style: {
      fill: "#003173"
    },
    x: 100.703,
    y: 75.557
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "matrix(1, 0, 0, 1, 116.382339, 87.613335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.72,101.83a2.52,2.52,0,0,0,2.52-2.52V92.47a2.52,2.52,0,0,0-5,0v6.84A2.52,2.52,0,0,0,87.72,101.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,105.45a2.52,2.52,0,0,0,2.52-2.52V96.09a2.52,2.52,0,1,0-5,0v6.84A2.52,2.52,0,0,0,78,105.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3,101.83a2.52,2.52,0,0,0,2.52-2.52V92.47a2.52,2.52,0,0,0-5,0v6.84A2.52,2.52,0,0,0,68.3,101.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.59,105.45a2.52,2.52,0,0,0,2.52-2.52V96.09a2.52,2.52,0,1,0-5,0v6.84A2.52,2.52,0,0,0,58.59,105.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.88,101.83a2.52,2.52,0,0,0,2.53-2.52V92.47a2.53,2.53,0,0,0-5,0v6.84A2.52,2.52,0,0,0,48.88,101.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.81,76.92a9.08,9.08,0,0,1,10.93-8.86,10.59,10.59,0,0,1,15-8.12,13.5,13.5,0,0,1,25.53,5.63A10.91,10.91,0,0,1,85.88,86h-37A9.06,9.06,0,0,1,39.81,76.92ZM86,81.34a6.27,6.27,0,0,0,2.36-12.08A6.36,6.36,0,0,0,86,68.79,6.26,6.26,0,0,0,81,71.19a2.66,2.66,0,1,1-4.18-3.29,11.53,11.53,0,0,1,9-4.43h.43l-.15-.4A8.83,8.83,0,0,0,70,62l-.09.17.13.16a11.29,11.29,0,0,1,2.59,7.2,2.66,2.66,0,1,1-5.32,0,6,6,0,0,0-11.94-.09v.14l.11.09a9.53,9.53,0,0,1,2.15,2.78,2.66,2.66,0,0,1-4.73,2.44,4.42,4.42,0,1,0-3.93,6.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.94,30.62a3,3,0,0,0-4.2.6l-5.31,7-3.16.36-6.88-5.2a3,3,0,0,0-4,4.44,3.33,3.33,0,0,0,.39.35l10.86,8.16a3.06,3.06,0,0,0,1.37.74h0a3.4,3.4,0,0,0,.46.06h.39l.12,0a2.93,2.93,0,0,0,.41-.07l.11,0A3,3,0,0,0,93.15,46l8.39-11.16A3,3,0,0,0,100.94,30.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.67,8.46a3,3,0,0,1-2.1-5.62c1-.37,2-.71,3-1h0c1.27-.37,2.58-.7,3.88-1a3,3,0,1,1,1.2,5.88c-1.13.23-2.27.52-3.38.85C34.43,7.84,33.54,8.14,32.67,8.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,14a42.71,42.71,0,0,0-4.4,3.79,3,3,0,0,1-4.22-4.26,47.26,47.26,0,0,1,5-4.34A3,3,0,1,1,22.5,14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.87,34.21A2.86,2.86,0,0,1,4.8,34a3,3,0,0,1-1.74-3.87,47.11,47.11,0,0,1,2.81-6A3,3,0,0,1,11.12,27a41.15,41.15,0,0,0-2.45,5.26A3,3,0,0,1,5.87,34.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.13,43.41a3,3,0,1,1,6,.44C6,44.93,6,46,6,47.14c0,.83,0,1.68.09,2.51a3,3,0,0,1-2.79,3.2H3.12a3,3,0,0,1-3-2.8C0,49.1,0,48.13,0,47.18,0,45.92,0,44.65.13,43.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.73,59.48A3,3,0,0,1,8.6,61.24,40.31,40.31,0,0,0,11,66.51a3,3,0,0,1-1.19,4.07A2.81,2.81,0,0,1,8.43,71a3,3,0,0,1-2.68-1.56,46.5,46.5,0,0,1-2.77-6A3,3,0,0,1,4.73,59.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.84,75.68c.65.66,1.34,1.31,2,1.92a3,3,0,0,1-3.19,5,3.08,3.08,0,0,1-.77-.5c-.8-.7-1.59-1.44-2.33-2.2a3,3,0,1,1,4.26-4.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.62,44.7l.35,0a3,3,0,0,0,2.63-3.33A46.92,46.92,0,0,0,50.19,0a3,3,0,1,0-.41,6A40.92,40.92,0,0,1,87.64,42.05,3,3,0,0,0,90.62,44.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,45.77l2.54-22.58a1.49,1.49,0,0,1,2.94,0l2.8,22.54A4.27,4.27,0,0,1,47.14,51h0A4.26,4.26,0,0,1,43,45.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.56,50.3,26.64,73.59a1.57,1.57,0,0,1-2.35-2l19-26.68a4.27,4.27,0,0,1,6.59-1.3h0A4.26,4.26,0,0,1,49.56,50.3Z",
    style: {
      fill: "#fff"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileRainFuture);
export default __webpack_public_path__ + "static/media/tile_RainFuture.d06f5c8fa0f69a391c783ac5ad840bb4.svg";
export { ForwardRef as ReactComponent };